import React from "react";
import { FaTrash } from "react-icons/fa";
import { FavoriteFiltersPopupProps } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const FavoriteFiltersPopup: React.FC<FavoriteFiltersPopupProps> = ({ isOpen, favoriteFilters, onApply, onRemove, onClose, }) => {
    if (!isOpen) return null;
    return (
        <div className="filter-popup-overlay">
            <div className="filter-popup-container">
                <div className="filter-popup-header">
                    <h3>Saved Filters</h3>
                    <button className="filter-popup-close" onClick={onClose}>&times;</button>
                </div>
                <div className="filter-popup-body">
                    {favoriteFilters.length > 0 ? (
                        <ul className="filter-list">
                            {favoriteFilters.map((favorite, index) => (
                                <li key={index} className="filter-item">
                                    <span className="filter-name" onClick={() => onApply(favorite)}>{favorite.name}</span>
                                    <button className="filter-remove-btn" onClick={() => onRemove(index)} title="Remove"> <FaTrash /></button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="no-filters-text">No favorite filters available.</p>
                    )}
                </div>
                <div className="filter-popup-footer">
                    <button className="filter-popup-close-btn" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};
export default FavoriteFiltersPopup;